import React from 'react';

import Container from './Container';
import PageButton from './PageButton';
import Page from './Page';

export default ({ model }) => (
  <Container>
    <PageButton area="prev" name="chevron-left" disabled={model.page === 1} page={model.page - 1} />
    <Page area="current">{model.page}</Page>
    <PageButton area="next" name="chevron-right" disabled={!model.hasMorePages} page={model.page + 1} />
  </Container>
);
